export default __webpack_public_path__ + "static/media/Dejan1.fef4b1c2.jpg";